module.exports = __webpack_public_path__ + "img/flowers.9bd77630.gif";